"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Paragraph"));



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Paragraph/index.ts
// module id = 621
// module chunks = 0